var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{class:['klook-svg', ("klook-svg_" + _vm.type), _vm.$options.class],style:(_vm.styles),on:{"click":function($event){$event.preventDefault();return _vm.$emit('click')}}},[_c('use',{attrs:{"xlink:href":("#" + _vm.type)}})])}
var staticRenderFns = []

export { render, staticRenderFns }